import React from 'react'
import { observer } from 'mobx-react-lite'
import useProfileBuildingSubmission from './hooks/useProfileBuildingSubmission'
import s from './styles/ProfileBuildingSubmission.module.scss'
import sharedStyles from '../shared/submissionStyles.module.scss'

const ProfileBuildingSubmission = observer(({ assignment, student }) => {
	const { completionPercentage, isLoading, responseText, hasResponse } = useProfileBuildingSubmission({
		assignment,
		student,
	})

	return (
		<div className={s.container}>
			<div className={sharedStyles.submission}>
				<div className={sharedStyles.submission__inner}>
					<span className={sharedStyles.title}>SUBMISSION</span>

					<div className={s.profile}>
						<div className={s.profile__badge}>
							{isLoading ? (
								<span className={sharedStyles.loading}>...</span>
							) : (
								<span className={s.badge}>{completionPercentage}%</span>
							)}
						</div>
						<span className={s.profile__label}>
							PROFILE COMPLETION PERCENTAGE
						</span>
					</div>

					<div className={sharedStyles.section}>
						<span className={sharedStyles.section__title}>
							Student's Response
						</span>
						<div className={sharedStyles.textArea}>
							{hasResponse ? (
								<p className={sharedStyles.textContent}>{responseText}</p>
							) : (
								<div className={sharedStyles.empty}>
									No response submitted yet
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
})

ProfileBuildingSubmission.displayName = 'ProfileBuildingSubmission'

export default ProfileBuildingSubmission
